// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../@nuxt/postcss8/node_modules/css-loader/dist/cjs.js??ref--4-oneOf-1-1!../../vue-loader/lib/loaders/stylePostLoader.js!../../postcss-loader/dist/cjs.js??ref--4-oneOf-1-2!../../@nuxt/components/dist/loader.js??ref--1-0!../../vue-loader/lib/index.js??vue-loader-options!./Icon.vue?vue&type=style&index=0&lang=css&");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../vue-style-loader/lib/addStylesClient.js").default
var update = add("4c27e420", content, true, {"sourceMap":false});